import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Snackbar, Tooltip } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import LinkIcon from '@mui/icons-material/Link';
import EmailIcon from '@mui/icons-material/Email';
import GroupsIcon from '@mui/icons-material/Groups';
import PrintIcon from '@mui/icons-material/Print';

export function shareTargets(url, title) {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  return {
    mailto: `mailto:?subject=${t}&body=${encodeURIComponent(`${title}\n${url}`)}`,
    teams: `https://teams.microsoft.com/share?href=${u}&msgText=${t}`,
  };
}

async function copy(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

// Header share icon: OS share sheet where the browser has one, otherwise a small menu.
export default function ShareButton() {
  const [anchor, setAnchor] = useState(null);
  const [note, setNote] = useState('');
  const current = () => ({ url: window.location.href, title: document.title || 'TEC Analytics' });

  const open = async (e) => {
    const { url, title } = current();
    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title, url });
      } catch { /* dismissed */ }
      return;
    }
    setAnchor(e.currentTarget);
  };
  const close = () => setAnchor(null);
  const { url, title } = current();
  const targets = shareTargets(url, title);

  return (
    <>
      <Tooltip title="Share this view">
        <IconButton color="inherit" size="small" onClick={open} sx={{ mr: 1 }} aria-label="Share this view">
          <ShareIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        <MenuItem onClick={async () => { close(); setNote((await copy(url)) ? 'Link copied' : 'Copy failed — copy the address bar'); }}>
          <ListItemIcon><LinkIcon fontSize="small" /></ListItemIcon><ListItemText>Copy link</ListItemText>
        </MenuItem>
        <MenuItem component="a" href={targets.mailto} onClick={close}>
          <ListItemIcon><EmailIcon fontSize="small" /></ListItemIcon><ListItemText>Email</ListItemText>
        </MenuItem>
        <MenuItem component="a" href={targets.teams} target="_blank" rel="noopener noreferrer" onClick={close}>
          <ListItemIcon><GroupsIcon fontSize="small" /></ListItemIcon><ListItemText>Teams</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { close(); setTimeout(() => window.print(), 100); }}>
          <ListItemIcon><PrintIcon fontSize="small" /></ListItemIcon><ListItemText>Print / PDF</ListItemText>
        </MenuItem>
      </Menu>
      <Snackbar open={Boolean(note)} autoHideDuration={2500} onClose={() => setNote('')} message={note} />
    </>
  );
}
